export default function LeadParagraph({ children }) {

	return (
		<p className="text-[#8a8f98] pb-6 text-lg sm:text-xl tracking-tighter font-medium">
			{children}
		</p>
	)
}
